import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, ComplainAttachment } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes, MasterConstants } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup, Staff_Search_Assigment } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ComplainService } from '../../Services/ComplainService';
import { CallDescriptionLookup, CallCategoryLookup, LocationLookup, ReasonLookup } from '../../Models/GlobalEntities';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'ParkEntry',
    templateUrl: './ParkEntry.html'
})

export class ParkEntry extends BaseComponent implements OnInit {
    @Input() Model: ComplainRegister;
    ShowDatePopup: boolean = false;
    DateFormat: string;

    cDate: Date = new Date();

    ReOpenTimeType: number = 1;

    Days: any;
    Hrs: any;
    Mins: any;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, private complainService: ComplainService, private modalService: NgbModal, private _sanitizer: DomSanitizer) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {
        this.DateFormat = this.masterService.GetPropertyDateFormat(this.Model.PropertyId);
        this.Model.ReopenTime = new Date();
    }

    onParkReasonChange(): void {
        if (this.Model.ClosedReasonCode_Park == null || this.Model.ClosedReasonCode_Park <= 0)
            return;

        let row: ReasonLookup = this.masterService.FindReason(this.Model.PropertyId, this.Model.ClosedReasonCode_Park);
        
        if (row == null)
            return;

        if (row.TimePeriod == null || row.TimePeriod <= 0)
            return;

        const period = row.TimePeriod || 0;
        const duration = moment.duration(period, 'minutes');

        this.Mins = duration.minutes().toString();
        this.Hrs = duration.hours().toString();
        this.Days = Math.floor(duration.asDays()).toString();

        this.ReOpenTimeType = 2;
    }

    onClear(): void {
        this.Mins = null;
        this.Days = null;
        this.Hrs = null;
        this.ReOpenTimeType = 1;
        this.Model.ReopenTime = null;
    }

    onTimeChange(): void {
        if (+this.ReOpenTimeType == 2) {
            let dt = moment();

            if (this.Days != null && this.Days > 0) {
                dt = dt.add(this.Days, 'days');
            }

            if (this.Hrs != null && this.Hrs > 0) {
                dt = dt.add(this.Hrs, 'hours');
            }

            if (this.Mins != null && this.Mins > 0) {
                dt = dt.add(this.Mins, 'minutes');
            }

            this.Model.ReopenTime = dt.toDate();
        }
    }
}
